module.exports = __webpack_public_path__ + "img/expert.5f545e8.gif?v=1763034624171";